// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container_2FqIm","cardText":"Main_cardText_OskhL","submitBtn":"Main_submitBtn_15dt2"};